import * as Yup from 'yup'

export const CreateSubcategorySchema = Yup.object({
  name: Yup.string().trim().required('Required'),
  imageUrl: Yup.array().min(1, 'Required')
})
